import * as S from "./icon-label.style";

const IconLabel = ({ bg, name, ...rest }) => {
  return <S.IconLabel bg={bg} name={name} {...rest}></S.IconLabel>;
};

export default IconLabel;
